export default __webpack_public_path__ + "static/media/logo-home.d53ad1da.png";